import {Injectable} from '@angular/core';
import {HttpHandler, HttpHeaders, HttpRequest} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {LocalStorageService} from 'angular-2-local-storage';
import {Profile} from '../domain/authentication/profile';
import {StorageItem} from '../enums/storage-item';
import {timeout} from 'rxjs/operators';
import {ConfigurationService} from '../services/configuration.service';

@Injectable()
export class EndpointInterceptor {

  unsecuredResources: any[];
  timeoutTimeMillis = 103000;

  constructor(private localStorage: LocalStorageService, private configurationService: ConfigurationService) {
    this.unsecuredResources = [
      {url: '/onboarding/authorizations', method: 'POST', type: 'full'},
      {url: '/catalog/postalcode', method: 'GET', type: 'partial'},
      {url: '/catalog', method: 'GET', type: 'partial'},
      {url: '/onboarding/applications/securityQuestions', method: 'GET', type: 'full'},
      {url: '/onboarding/applications?applicationToken', method: 'GET', type: 'partial'},
      {url: '/onboarding/applications/contracts', method: 'POST', type: 'partial'},
      {url: '/onboarding/applications', method: 'POST', type: 'partial'},
      {url: '/onboarding/authorizations/phone/validate-availability', method: 'POST', type: 'full'},
      {url: '/onboarding/authorizations/email/validate-availability', method: 'POST', type: 'full'},
      {url: '/onboarding/authorizations/otp/phone-validate', method: 'POST', type: 'full'},
      {url: '/onboarding/authorizations/otp/email-validate', method: 'POST', type: 'full'},
      {url: '/accounts/exchangeRate', method: 'PUT', type: 'full'},
      {url: '/onboarding/applications/', method: 'GET', type: 'partial'},
      {url: '/onboarding/user/recover', method: 'POST', type: 'full'},
      {url: '/onboarding/user/reset', method: 'PUT', type: 'partial'},
      {url: '/onboarding/user/confirmation/', method: 'PUT', type: 'partial'},
      {url: '/accounts/currencies/exchange-rate', method: 'GET', type: 'partial'},
      {url: '/onboarding/user/cancel', method: 'PUT', type: 'partial'},
      {url: '/accounts/public/contact', method: 'POST', type: 'partial'},
      {url: '/configurations', method: 'GET', type: 'full'}
    ];
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const gatewayUrl = '/spiral/gateway';
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    let headers: HttpHeaders;
    headers = new HttpHeaders({
      Authorization: environment.webToken,
      'Accept-Language': profile ? profile.locale : navigator.language.substring(0, 2)
    });
    let isOpen = false;
    for (const item of this.unsecuredResources) {
      if (item.method === req.method) {
        switch (item.type) {
          case 'full':
            if (item.url === req.url) {
              isOpen = true;
            }
            break;
          case 'partial':
            if (req.url.startsWith(item.url)) {
              isOpen = true;
            }
            break;
        }
      }
    }
    if (!isOpen) {
      // FIXME quitar esta condición, dejarla en el único método que lo usa y ponerlo en configuración
      if (req.url !== '/onboarding/applications') {
        headers = new HttpHeaders({
          Authorization: `Bearer ${profile.accessToken}`,
          'Accept-Language': profile ? profile.locale : navigator.language.substring(0, 2),
        });
      }
    } else {

    }
    const newRequest = req.clone({
      url: `${environment.serviceEndpoint}/spiral/gateway${req.url}`,
      headers
    });

    if (req.url.startsWith('/onboarding/applications/response') &&
      this.configurationService.application.maxTimeToWaitCardCreateInMillis > 103000) {
      this.timeoutTimeMillis = this.configurationService.application.maxTimeToWaitCardCreateInMillis + 1000;
    }
    return next.handle(newRequest).pipe(timeout(this.timeoutTimeMillis));
  }
}
